/**
 * Returnerer de puljer på et fag, der ikke følger brikken, dvs. de
 * subject_calendars der har et eksplicit timetal sat (hours != null) – også
 * selvom værdien tilfældigvis er den samme som brikkens.
 *
 * Angives targetHours, udelades puljer der allerede har netop det timetal,
 * da de ikke behøver at blive opdateret.
 *
 * @param {Object} subject - faget (typisk editSubject fra showSubject)
 * @param {*} [targetHours] - brikkens (nye) klokketimer
 * @returns {Array<{calendarId: number, hours: *}>}
 */
export function getDifferentiatedPools (subject, targetHours) {
  if (!subject || !Array.isArray(subject.subject_calendars)) {
    return []
  }
  const target = parseFloat(targetHours)
  const compareToTarget = targetHours !== undefined && !isNaN(target)
  return subject.subject_calendars
    .filter(function (sc) {
      if (!sc || sc.hours === null || sc.hours === undefined) return false
      if (!compareToTarget) return true
      return parseFloat(sc.hours) !== target
    })
    .map(function (sc) {
      return {
        calendarId: sc.calendar_id,
        hours: sc.hours
      }
    })
}

/**
 * Er der mindst én pulje på faget, der ikke følger brikken (og ikke allerede
 * matcher targetHours)? Bruges til at afgøre, om bekræftelses-modalen skal vises.
 */
export function hasDifferentiatedPool (subject, targetHours) {
  return getDifferentiatedPools(subject, targetHours).length > 0
}

function toHoursNumber (value) {
  if (value === null || value === undefined || value === '') return null
  const n = parseFloat(String(value).replace(',', '.'))
  return isNaN(n) ? null : n
}

/**
 * Skal bekræftelses-modalen om puljer vises? Kun hvis brikkens klokketimer
 * er ændret i forhold til det gemte fag, og der findes puljer der afviger.
 */
export function shouldConfirmPoolsUpdate (subject, targetHours) {
  if (!subject) return false
  if (toHoursNumber(subject.hours) === toHoursNumber(targetHours)) return false
  return hasDifferentiatedPool(subject, targetHours)
}



// WEBPACK FOOTER //
// ./src/utils/subjectPools.js